import { ObjetKStatus } from '@siclop/kstone-vue'
import type { EstimationScale } from '@/modules/estimation/models/EstimationScale'

export class ProjectType extends ObjetKStatus {
  code: string = ''
  label: string = ''
  description?: string
  icon?: string
  order: number = 0
  isActive: boolean = true
  estimationScaleIds: number[] = []
  estimationScales?: EstimationScale[]

  constructor(data?: Partial<ProjectType>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.label = data.label ?? ''
      this.description = data.description
      this.icon = data.icon
      this.order = data.order ?? 0
      this.isActive = data.isActive ?? true
      this.estimationScaleIds = data.estimationScaleIds ?? []
      this.estimationScales = data.estimationScales
    }
  }
}
